// extracted by mini-css-extract-plugin
export default {"body":"coursetags_body__sXxC-"};